import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});
// instance.interceptors.request.use(async (config) => {
// config.params = config.params || {};

// const method = config.method?.toLowerCase();
// const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");

// if (needsCsrf) {
// const res = await instance.get("/api/csrf-token");
// config.headers["X-CSRF-Token"] = res.data.csrfToken;
// }

// return config;
// });
const ApiInterceptor = () => {
  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response?.status === 401) {
        if (error.config) {
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    }
  );
  return null;
};
ApiInterceptor();
const apiRequest = {
  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/sendOtp`, body),
  resetPassword: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/resetPassword`, body),

  verifyOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/verifyOtp`, body),

  getDashboardData: ({ v = "v1" } = {}) =>
    instance.get(`/api/tower-head-admin/${v}/getDashboardData`, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),
  getProfile: ({ v = "v1" } = {}) =>
    instance.get(`/api/tower-head-admin/${v}/profile`, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  getExcelImportList: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/tower-head-admin/${v}/excel/imports`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    });
  },

  getCorporateAdminByHeadAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(
      `/api/tower-head-admin/${v}/getCorporateAdmins`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    );
  },

  getSuperVendorsByCorporateAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(`/api/tower-head-admin/${v}/vendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    });
  },

  getHeadVendors: ({ v = "v1", body } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/vendor/getHeadVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),
  getVendorsBySuperVendor: ({ v = "v1", body } = {}) =>
    instance.post(
      `/api/tower-head-admin/${v}/vendor/getVendorsBySuperVendor`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    ),

  getVendorWithAdmin: ({ v = "v1", body } = {}) =>
    instance.post(
      `/api/tower-head-admin/${v}/vendor/getVendorWithAdmin`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    ),

  getGallery: ({ v = "v1", body } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/gallery`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  createGallery: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(
      `/api/tower-head-admin/${v}/gallery/create`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    );
  },

  updateGallery: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(`/api/tower-head-admin/${v}/gallery/${id}`, formData, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  deleteGallery: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/tower-head-admin/${v}/gallery/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  getVendorCompliance: ({ v = "v1", body } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/vendorCompliance`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  createVendorCompliance: ({ v = "v1", formData = {} } = {}) => {
    return instance.post(
      `/api/tower-head-admin/${v}/vendorCompliance/create`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    );
  },

  updateVendorCompliance: ({ v = "v1", id = "", formData = {} } = {}) =>
    instance.put(
      `/api/tower-head-admin/${v}/vendorCompliance/${id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    ),

  deleteVendorCompliance: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/tower-head-admin/${v}/vendorCompliance/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  getAdmin: ({ v = "v1", body } = {}) => {
    return instance.post(
      `/api/tower-head-admin/${v}/getCorporateAdmins`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    );
  },

  // corporate admin
  createCorporateAdmin: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/head-admin/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  editCorporateAdmin: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/tower-head-admin/${v}/head-admin/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  deleteCorporateAdmin: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/tower-head-admin/${v}/head-admin/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  getProducts: ({ v = "v1", body } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/product/getProducts`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  // vendor
  getVendor: ({ v = "v1", body } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/vendor`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  getVendorById: ({ v = "v1", id = "", body } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/vendor/getStaffVendors`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),
  createVendor: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/tower-head-admin/${v}/vendor/create`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),
  editVendor: ({ v = "v1", id = "", body = {} } = {}) =>
    instance.put(`/api/tower-head-admin/${v}/vendor/${id}`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),
  deleteVendor: ({ v = "v1", id = "" } = {}) =>
    instance.delete(`/api/tower-head-admin/${v}/vendor/${id}`, {
      headers: {
        Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
      },
    }),

  getVendorManagerForSelect: ({ v = "v1", body } = {}) =>
    instance.post(
      `/api/tower-head-admin/${v}/vendor/vendor-manager-list`,
      body,
      {
        headers: {
          Authorization: `Bearer ${authManager.getTowerHeadAdminAccessToken()}`,
        },
      }
    ),
};

export default apiRequest;
